// extracted by mini-css-extract-plugin
module.exports = {"FTSkeleton":"FTSkeleton_FTSkeleton__33Ttb","item":"FTSkeleton_item__3fMXZ","itemInnerBox":"FTSkeleton_itemInnerBox__3THV7"};